import React from 'react';
import UseGiphyPreview from "./GiphyPreview.hooks";
import { makeGiphyTemplate } from '../embedUtilities';

const GiphyPreview = ({url, setDisableUpload, setIsLoading, isLoading, setEmbedId}:{url: string, setDisableUpload: any, setIsLoading: any, isLoading: boolean, setEmbedId:any}) => {

    const {id} = UseGiphyPreview(url, isLoading, setIsLoading, setDisableUpload);

    if (isLoading) {
        return <div className="spacer" />
    }

    if (!id) {
        return <span className="error-message">We couldn't find a source for that Giphy embed. Please try again.</span>
    } else {
        setEmbedId(id);

        return ( 
            <div className='embed-preview-container giphy-preview'>
                <div className="preview-tab">Preview</div>
    
                <div dangerouslySetInnerHTML={{__html:makeGiphyTemplate(id)}}/>
            </div>
        )
    }
}

export default GiphyPreview
